import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import ListaSolicitudesVisita from '../componentes/ListaSolicitudesVisitas';

const SolicitudVisitas = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Solicitudes Pendientes - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <ListaSolicitudesVisita />
        </>
    );
}

export default SolicitudVisitas;